import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Row, Col } from 'react-bootstrap';
import { Redirect, Route, Switch } from "react-router-dom";

import Header from '../../layout/header';
import BreadcrumbList from "../../layout/breadcrumbs";
import pages from "../../constants/menu";
import breadcrumbs from "../../layout/breadcrumbs/calculate";
import pageIdentity from "./page-identity";
import Layout from "../../layout";
import SummaryViewer from "../summary";
import ProfileEditor from "../profile";
import ProductEditor from "../product";
import MethodsEditor from "../billing/methods";
import BillingList from "../billing/history";
import Orders from "../orders";
import NotificationsPage from "../notifications";
import ProductManagementInvitation from "../invitations/product-management";
import Settings from "../settings";
import SettingsAreas from "../settings/areas";
import SettingsAreaEditor from "../settings/areas/item";
import SettingsProducts from "../settings/products";
import SettingsProductEditor from "../settings/products/item";
import SuperAdminConsole from "../super-admin";
import { canViewFeradelAdministration, canViewSuperAdmin } from "../../constants/permissions";
import Spinner from "../../layout/spinner";

class Dashboard extends React.Component {
    
    constructor(props) {
        super(props);

        this.state = {
            modal: {
                license: {

                }
            }
        }
    }

    componentDidUpdate(oldProps) {

    }

    get pathname() {
        return this.props.location?.pathname || window.location.pathname;
    }

    get identity() {
        return pageIdentity(this.pathname, this.props.page);
    }

    render() {
        const identity = this.identity;
        const isProductSummary = this.pathname === "/dashboard";
        const canViewAdministration = canViewFeradelAdministration(this.props.auth?.permissions);
        const canViewSuper = canViewSuperAdmin(this.props.auth?.permissions);
        const isSuperAdminRoute = this.pathname.startsWith("/super-admin");
        return (
            <>
                <Layout>
                    <Header title={`Feradel License Manager | ${identity.title}`} description={`${this.props.profile?.dashboardTitleBase} | ${identity.routePage.description || ""}`} />

                    {/* Title and Top Buttons Start */}
                    <div className={`page-title-container ${isProductSummary ? "product-summary-route" : ""}`}>
                        {!isProductSummary && !isSuperAdminRoute ? <Row>
                            {/* Title Start */}
                            <Col md="4">
                                <h1 className="mb-0 pb-0 display-4">{identity.title}</h1>
                                <BreadcrumbList items={breadcrumbs(this.pathname, pages)} title={identity.breadcrumb} />
                            </Col>
                        </Row> : null}
                        <Row>
                            <Switch>
                                <Route exact path="/dashboard" component={SummaryViewer}></Route>
                                {canViewSuper ? <Route path="/super-admin" component={SuperAdminConsole}></Route> : null}
                                {isSuperAdminRoute && !this.props.auth?.permissionsLoaded ? <Route path="/super-admin" component={Spinner}></Route> : null}
                                <Route exact path="/dashboard/profile/me" component={ProfileEditor}></Route>
                                <Route exact path="/dashboard/products/:uuid" component={ProductEditor}></Route>
                                <Route exact path="/dashboard/billing/history" component={BillingList}></Route>
                                <Route exact path="/dashboard/billing/methods" component={MethodsEditor}></Route>
                                <Route exact path="/dashboard/orders" component={Orders}></Route>
                                <Route exact path="/dashboard/notifications" component={NotificationsPage}></Route>
                                <Route exact path="/dashboard/invitations/:productUuid/:invitationUuid" component={ProductManagementInvitation}></Route>
                                {canViewAdministration ? <Route exact path="/dashboard/settings" component={Settings}></Route> : null}
                                {canViewAdministration ? <Route exact path="/dashboard/settings/areas" component={SettingsAreas}></Route> : null}
                                {canViewAdministration ? <Route exact path="/dashboard/settings/areas/:uuid" component={SettingsAreaEditor}></Route> : null}
                                {canViewAdministration ? <Route exact path="/dashboard/settings/products" component={SettingsProducts}></Route> : null}
                                {canViewAdministration ? <Route exact path="/dashboard/settings/products/:uuid" component={SettingsProductEditor}></Route> : null}
                                {!canViewAdministration ? <Redirect from="/dashboard/settings" to="/dashboard" /> : null}
                                {!canViewSuper && isSuperAdminRoute && this.props.auth?.permissionsLoaded ? <Redirect to="/dashboard" /> : null}
                            </Switch>
                        </Row>
                    </div>
                    {/* Title and Top Buttons End */}
                    
                </Layout>
            </>
        );
    }
}

Dashboard.propTypes = {
    auth: PropTypes.object.isRequired,
    profile: PropTypes.object
};

const mapStateToProps = (state) => {
    return ({
        auth: state.auth,
        profile: state.licensee.profile,
        page: state.page,
    });
};

export default connect(mapStateToProps)(Dashboard);
